module.exports = __webpack_public_path__ + "img/beach-1110498_640.67443f45.jpg";